type RuleValidator<T> = (params: T) => boolean;

function getKeyByRule<T>(
  keyMap: Dynamic<string>,
  rules: Dynamic<RuleValidator<T>>,
  params: T,
  defaultKey: string
): string {
  const result = Object.entries(rules).find(([, validator]: [string, RuleValidator<T>]): boolean => validator(params));
  if (result) {
    const [key] = result;
    return keyMap[key];
  }
  return keyMap[defaultKey];
}

function singularValidator(param: number): boolean {
  return param === 1;
}
function specialPluralValidatorPL(param: number): boolean {
  const tensDigit = Math.floor(param / 10) % 10;
  const onesDigit = param % 10;
  return tensDigit !== 1 && (onesDigit === 2 || onesDigit === 3 || onesDigit === 4);
}

export type KeyMap = {
  singular: string;
  plural: string;
  pluralSpecial?: string;
};

type KeyGetterByCount = (keyMap: KeyMap, count: number) => string;

function getKeyByCountPL(keyMap: KeyMap, count: number): string {
  return getKeyByRule(
    keyMap,
    {
      singular: singularValidator,
      pluralSpecial: specialPluralValidatorPL,
    },
    count,
    'plural'
  );
}

function getKeyByCount(keyMap: KeyMap, count: number): string {
  return getKeyByRule(
    keyMap,
    {
      singular: singularValidator,
    },
    count,
    'plural'
  );
}

const keyGetterLanguageMap: Dynamic<KeyGetterByCount> = {
  pl_PL: getKeyByCountPL,
  default: getKeyByCount,
};

export function getKeyGetter(locale: string): KeyGetterByCount {
  return keyGetterLanguageMap[locale] || keyGetterLanguageMap.default;
}
